import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SharedService } from '../services/shared.service';
import { AccessibilityService } from '../services/accessibility.service';
import * as $ from 'jquery';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'online-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  currentUser: any;

  //change font size variables
  counter: number = 2;

  skipClass: string = "headerskipblur";

  constructor(private router: Router,
    public sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private accessibilityService: AccessibilityService,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.currentUser = this.activatedRoute.snapshot.data['currentUser'];
  }

  ngOnDestroy() {
    localStorage.removeItem("userInfo");
  }

  onChange(value: string): void {
    if (value === 'logout') {
      this.logout();
    }
  }


  logout(): void {
    const userType = localStorage.getItem('userType');

    localStorage.clear();
    this.authService.logout();

    if (userType === 'student') {
      this.router.navigate(['/welcome']);
    } else if (userType === 'agent') {
      this.router.navigate(['/welcome-agent']);
    }
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid white";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  skipNavFocusAccessibility(event): void {
    this.skipClass = "headerskip"
  }

  skipNavBlurAccessibility(event): void {
    this.skipClass = "headerskipblur"
  }

  skipNavAccessibility(): void {
    $('#mainContent').focus();
  }

  //Accessibility -- resize font
  increaseFontSize(): void {
    if (this.counter < 4) {
      this.counter++;
    }
    switch (this.counter) {
      case 3: {
        this.accessibilityService.resizeFontSize("size15");
        this.openSnackBar("Current Font Percentage: 150%", "");
        this.removeClassFromToolTip();
        $('.cdk-overlay-container').addClass("size15");
        break;
      }
      case 4: {
        this.accessibilityService.resizeFontSize("size20");
        this.removeClassFromToolTip();
        this.openSnackBar("Current Font Percentage: 200%", "");
        $('.cdk-overlay-container').addClass("size20");
        break;
      }
      case 1: {
        this.accessibilityService.resizeFontSize("size05");
        this.removeClassFromToolTip();
        this.openSnackBar("Current Font Percentage: 75%", "");
        $('.cdk-overlay-container').addClass("size05");
        break;
      }
      case 2: {
        this.openSnackBar("Current Font Percentage: 100%", "");
        this.accessibilityService.resizeFontSize("");
        this.removeClassFromToolTip();
        break;
      }
    }
  }

  decreaseFontSize(): void {
    if (this.counter > 0) {
      this.counter--;
    }
    switch (this.counter) {
      case 2: {
        this.accessibilityService.resizeFontSize("");
        this.openSnackBar("Current Font Percentage: 100%", "");
        this.removeClassFromToolTip();
        break;
      }
      case 3: {
        this.accessibilityService.resizeFontSize("size15");
        this.openSnackBar("Current Font Percentage: 150%", "");
        this.removeClassFromToolTip();
        $('.cdk-overlay-container').addClass("size15");
        break;
      }
      case 1: {
        this.accessibilityService.resizeFontSize("size05");
        this.openSnackBar("Current Font Percentage: 75%", "");
        this.removeClassFromToolTip();
        $('.cdk-overlay-container').addClass("size05");
        break;
      }
      case 0: {
        this.accessibilityService.resizeFontSize("size00");
        this.openSnackBar("Current Font Percentage: 50%", "");
        this.removeClassFromToolTip();
        $('.cdk-overlay-container').addClass("size00");
        break;
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'top'
    });
  }

  removeClassFromToolTip(): void {
    $('.cdk-overlay-container').removeClass("size15");
    $('.cdk-overlay-container').removeClass("size20");
    $('.cdk-overlay-container').removeClass("size00");
    $('.cdk-overlay-container').removeClass("size05");
  }
}
